/* eslint-disabled  react/jsx-indent */
import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import TaxPayerInformation from 'modules/common/components/TaxPayerInformation';
import * as action from '../action';
import * as c from '../constant';

function SubscriberContent({
  // clearTransaction,
  showTransaction,
  isLoading,
  match,
  taxpayer,
}) {
  const selectedTransaction = match.params.id;
  const updateData = () => {
    showTransaction(selectedTransaction);
  };

  useEffect(() => {
    if (!_.isEmpty(selectedTransaction)) {
      updateData();
    }
  }, [selectedTransaction]);

  return (
    <>
      <div className="card-section-content container-fluid citizen-tabs">
        {isLoading && (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        )}
        <div className="right-section-content mt-0">
          {/* GRAY HIGHLIGHT */}

          <div className="row highlight d-flex align-items-center mx-3 py-3">
            <div className="col-12 px-0 mt-0 mb-1">
              {/* BORDER */}
              <div className="card border-primary">
                <div className="container-fluid py-1">
                  <TaxPayerInformation data={taxpayer} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

SubscriberContent.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  taxpayer: PropTypes.instanceOf(Object).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  // clearTransaction: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  taxpayer:
    {
      ...(_.get(api, `${c.SHOW_TRANSACTION}.item`) || {}),
    } || {},
  isLoading: api.loading.indexOf(c.SHOW_TRANSACTION) > -1,
  activating: api.loading.indexOf(c.ACTIVATE_PROFILE) > -1,
  selectedBirth: _.get(match, 'params.birthId') || '',
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, action)]);

export default enhance(SubscriberContent);
